import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $SharingPageLevelTraffic } from 'shared/atoms';
import {
  useHashtagCoverImage,
  useHashtagDescription,
  useHashtagLinkPreviewTitle,
} from '@hashtag/shared/use-hashtag-tdk';

export const HashtagOG: FC = () => {
  const { canonicalUrl } = useAtomValue($SharingPageLevelTraffic);
  const title = useHashtagLinkPreviewTitle();
  const description = useHashtagDescription();
  const cover = useHashtagCoverImage();

  return (
    <>
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {cover && (
        <>
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image" content={cover.url} />
          <meta property="og:image:width" content={`${cover.width}`} />
          <meta property="og:image:height" content={`${cover.height}`} />
        </>
      )}
    </>
  );
};
